var map = {
	"./avatars/abld_alligator/default.png": 87164,
	"./avatars/abld_bird/default.png": 45700,
	"./avatars/abld_brown_bear/default.png": 69552,
	"./avatars/abld_butterfly/default.png": 33924,
	"./avatars/abld_cat/default.png": 73089,
	"./avatars/abld_clownfish/default.png": 63832,
	"./avatars/abld_dog/default.png": 11247,
	"./avatars/abld_dolphin/default.png": 34113,
	"./avatars/abld_elephant/default.png": 25558,
	"./avatars/abld_frog/default.png": 72347,
	"./avatars/abld_giraffe/default.png": 22633,
	"./avatars/abld_goldfish/default.png": 66581,
	"./avatars/abld_goose/default.png": 18048,
	"./avatars/abld_hamster/default.png": 43779,
	"./avatars/abld_horse/default.png": 36702,
	"./avatars/abld_iguana/default.png": 57812,
	"./avatars/abld_koala_bear/default.png": 21174,
	"./avatars/abld_leopard/default.png": 53426,
	"./avatars/abld_lion/default.png": 11223,
	"./avatars/abld_monkey/default.png": 64730,
	"./avatars/abld_orca_whale/default.png": 81720,
	"./avatars/abld_panda_bear/default.png": 18012,
	"./avatars/abld_parrot/default.png": 37701,
	"./avatars/abld_penguin/default.png": 58285,
	"./avatars/abld_rabbit/default.png": 60853,
	"./avatars/abld_racoon/default.png": 20551,
	"./avatars/abld_sea_turtle/default.png": 62871,
	"./avatars/abld_seahorse/default.png": 80837,
	"./avatars/abld_shark/default.png": 98558,
	"./avatars/abld_sheep/default.png": 61520,
	"./avatars/abld_shell/default.png": 19191,
	"./avatars/abld_sloth/default.png": 26489,
	"./avatars/abld_starfish/default.png": 69679,
	"./avatars/abld_tiger/default.png": 65328,
	"./avatars/abld_turtle/default.png": 3335,
	"./avatars/abld_zebra/default.png": 51333,
	"./avatars/ace/default.png": 67996,
	"./avatars/calvin/default.png": 67126,
	"./avatars/cat/default.png": 76653,
	"./avatars/chuck/celebrate.svg": 83810,
	"./avatars/chuck/default.svg": 87470,
	"./avatars/chuck/primary.svg": 4159,
	"./avatars/chuck/secondary.svg": 14143,
	"./avatars/chuck/vehicle.svg": 26081,
	"./avatars/clyde/celebrate.svg": 41829,
	"./avatars/clyde/default.svg": 41925,
	"./avatars/clyde/primary.svg": 56828,
	"./avatars/clyde/secondary.svg": 76436,
	"./avatars/clyde/vehicle.svg": 41474,
	"./avatars/crabby/celebrate.svg": 13051,
	"./avatars/crabby/default.svg": 40843,
	"./avatars/crabby/primary.svg": 57046,
	"./avatars/crabby/secondary.svg": 38722,
	"./avatars/crabby/vehicle.svg": 45636,
	"./avatars/daisy/celebrate.svg": 57700,
	"./avatars/daisy/default.svg": 83504,
	"./avatars/daisy/primary.svg": 86133,
	"./avatars/daisy/secondary.svg": 59201,
	"./avatars/daisy/vehicle.svg": 6599,
	"./avatars/dash/default.png": 42781,
	"./avatars/denver/default.png": 48529,
	"./avatars/duke/default.png": 99124,
	"./avatars/elk/default.png": 78023,
	"./avatars/fox/default.png": 32490,
	"./avatars/fuzzy/celebrate.svg": 14902,
	"./avatars/fuzzy/default.svg": 33034,
	"./avatars/fuzzy/primary.svg": 86435,
	"./avatars/fuzzy/secondary.svg": 14075,
	"./avatars/fuzzy/vehicle.svg": 61165,
	"./avatars/gadget/default.png": 28837,
	"./avatars/giraffe/default.png": 49613,
	"./avatars/grizzly/default.png": 89404,
	"./avatars/hank/celebrate.svg": 91342,
	"./avatars/hank/default.svg": 90114,
	"./avatars/hank/primary.svg": 85083,
	"./avatars/hank/secondary.svg": 66291,
	"./avatars/hank/vehicle.svg": 25093,
	"./avatars/happy/celebrate.svg": 54932,
	"./avatars/happy/default.svg": 33728,
	"./avatars/happy/primary.svg": 56389,
	"./avatars/happy/secondary.svg": 52273,
	"./avatars/happy/vehicle.svg": 59319,
	"./avatars/harley/default.png": 8064,
	"./avatars/harry/default.png": 53031,
	"./avatars/harryk5/celebrate.svg": 9348,
	"./avatars/harryk5/default.svg": 79216,
	"./avatars/harryk5/primary.svg": 65493,
	"./avatars/harryk5/secondary.svg": 10849,
	"./avatars/harryk5/vehicle.svg": 2311,
	"./avatars/horse/default.png": 16114,
	"./avatars/hux/default.png": 42610,
	"./avatars/iggy/default.png": 72449,
	"./avatars/jg/celebrate.svg": 53519,
	"./avatars/jg/default.svg": 22007,
	"./avatars/jg/primary.svg": 3978,
	"./avatars/jg/secondary.svg": 82142,
	"./avatars/jg/vehicle.svg": 34960,
	"./avatars/joe/celebrate.svg": 25064,
	"./avatars/joe/default.svg": 31740,
	"./avatars/joe/primary.svg": 22473,
	"./avatars/joe/secondary.svg": 221,
	"./avatars/joe/vehicle.svg": 2707,
	"./avatars/joseph/celebrate.svg": 27035,
	"./avatars/joseph/default.svg": 77963,
	"./avatars/joseph/primary.svg": 23830,
	"./avatars/joseph/secondary.svg": 53122,
	"./avatars/joseph/vehicle.svg": 94916,
	"./avatars/june/celebrate.svg": 32426,
	"./avatars/june/default.svg": 44342,
	"./avatars/june/primary.svg": 65095,
	"./avatars/june/secondary.svg": 18599,
	"./avatars/june/vehicle.svg": 62793,
	"./avatars/kai/default.png": 6248,
	"./avatars/legs/celebrate.svg": 485,
	"./avatars/legs/default.svg": 25381,
	"./avatars/lenny/default.png": 29639,
	"./avatars/lily/celebrate.svg": 28930,
	"./avatars/lily/default.svg": 69390,
	"./avatars/lily/primary.svg": 78047,
	"./avatars/lily/secondary.svg": 94463,
	"./avatars/lily/vehicle.svg": 90401,
	"./avatars/lion/default.png": 53499,
	"./avatars/meg/default.png": 39432,
	"./avatars/mel/celebrate.svg": 98300,
	"./avatars/mel/default.svg": 7688,
	"./avatars/mel/primary.svg": 46029,
	"./avatars/mel/secondary.svg": 76217,
	"./avatars/mel/vehicle.svg": 43327,
	"./avatars/miles/default.png": 26691,
	"./avatars/mo/default.png": 11929,
	"./avatars/monkey/default.png": 91430,
	"./avatars/nano/default.png": 47639,
	"./avatars/oakley/default.png": 85782,
	"./avatars/ollie/default.png": 41176,
	"./avatars/otto/default.png": 47663,
	"./avatars/panda/default.png": 82609,
	"./avatars/pixel/default.png": 10417,
	"./avatars/raccoon/default.png": 25842,
	"./avatars/red/default.png": 21772,
	"./avatars/remy/default.png": 89116,
	"./avatars/rex/default.png": 11960,
	"./avatars/rocket/celebrate.svg": 38018,
	"./avatars/rocket/default.svg": 83374,
	"./avatars/rocket/primary.svg": 17375,
	"./avatars/rocket/secondary.svg": 59679,
	"./avatars/rocket/vehicle.svg": 92673,
	"./avatars/rocky/celebrate.svg": 53050,
	"./avatars/rocky/default.svg": 5542,
	"./avatars/rocky/primary.svg": 68599,
	"./avatars/rocky/secondary.svg": 15607,
	"./avatars/rocky/vehicle.svg": 53337,
	"./avatars/rose/celebrate.svg": 72355,
	"./avatars/rose/default.svg": 40691,
	"./avatars/rose/primary.svg": 99070,
	"./avatars/rose/secondary.svg": 47306,
	"./avatars/rose/vehicle.svg": 71020,
	"./avatars/ruby/default.png": 43601,
	"./avatars/shark/default.png": 36930,
	"./avatars/sid/celebrate.svg": 22550,
	"./avatars/sid/default.svg": 94890,
	"./avatars/sid/primary.svg": 97891,
	"./avatars/sid/secondary.svg": 90651,
	"./avatars/sid/vehicle.svg": 60909,
	"./avatars/sky/default.png": 42618,
	"./avatars/smiley/default.png": 37468,
	"./avatars/smoky/default.png": 8170,
	"./avatars/sonny/default.png": 75338,
	"./avatars/sparkle/celebrate.svg": 36744,
	"./avatars/sparkle/default.svg": 12188,
	"./avatars/sparkle/primary.svg": 50825,
	"./avatars/sparkle/secondary.svg": 93181,
	"./avatars/sparkle/vehicle.svg": 26867,
	"./avatars/spike/default.png": 39599,
	"./avatars/sunny/celebrate.svg": 87511,
	"./avatars/sunny/default.svg": 53983,
	"./avatars/sunny/primary.svg": 60434,
	"./avatars/sunny/secondary.svg": 6342,
	"./avatars/sunny/vehicle.svg": 86296,
	"./avatars/tango/default.png": 17334,
	"./avatars/tulip/celebrate.svg": 72774,
	"./avatars/tulip/default.svg": 99802,
	"./avatars/tulip/primary.svg": 10899,
	"./avatars/tulip/secondary.svg": 68203,
	"./avatars/tulip/vehicle.svg": 35165,
	"./avatars/zelda/default.png": 50169,
	"./backgrounds/amusement.jpg": 69429,
	"./backgrounds/ancient-ruins.jpg": 18524,
	"./backgrounds/big-wave.jpg": 58240,
	"./backgrounds/blue-sea.svg": 26385,
	"./backgrounds/blue-sky.svg": 51907,
	"./backgrounds/bright-swatches.jpg": 57811,
	"./backgrounds/cacti.png": 17804,
	"./backgrounds/cool-cat.png": 55044,
	"./backgrounds/cosmos.png": 11892,
	"./backgrounds/crimson-space.svg": 47007,
	"./backgrounds/dark-galaxy.svg": 14724,
	"./backgrounds/deep-dive.svg": 43960,
	"./backgrounds/deep-space.jpg": 16955,
	"./backgrounds/desert-flower.svg": 30344,
	"./backgrounds/desert-sunset.jpg": 56380,
	"./backgrounds/desert.svg": 24792,
	"./backgrounds/dog.png": 67712,
	"./backgrounds/fish-party.jpg": 80793,
	"./backgrounds/forest.svg": 26364,
	"./backgrounds/happy-hills.svg": 45736,
	"./backgrounds/happy-puppy-68.jpg": 97242,
	"./backgrounds/happy-puppy.jpg": 14481,
	"./backgrounds/horseshoe-bend.jpg": 47834,
	"./backgrounds/jellyfish.png": 44360,
	"./backgrounds/leaves.jpg": 30996,
	"./backgrounds/login.png": 10829,
	"./backgrounds/machu-picchu.jpg": 49139,
	"./backgrounds/math.png": 61342,
	"./backgrounds/mountain-falls.jpg": 86172,
	"./backgrounds/mountain-lake.svg": 81470,
	"./backgrounds/mountains-k5.svg": 67626,
	"./backgrounds/mountains.jpg": 73982,
	"./backgrounds/mountainside.svg": 66519,
	"./backgrounds/nap-time.jpg": 83065,
	"./backgrounds/night-sky.svg": 49095,
	"./backgrounds/ocean.svg": 63271,
	"./backgrounds/panda.png": 26866,
	"./backgrounds/pink-pattern.png": 20045,
	"./backgrounds/purple-pattern.svg": 36800,
	"./backgrounds/purple-pinwheel.svg": 53440,
	"./backgrounds/pyramids.jpg": 60583,
	"./backgrounds/reading.png": 14050,
	"./backgrounds/sea-coral.jpg": 92867,
	"./backgrounds/sea-plants.svg": 51807,
	"./backgrounds/space-desert.svg": 92575,
	"./backgrounds/space-kitty.jpg": 38046,
	"./backgrounds/space-light.jpg": 12439,
	"./backgrounds/space-odyssey.svg": 46590,
	"./backgrounds/spider-web.jpg": 59186,
	"./backgrounds/sunny-galaxy.svg": 13965,
	"./backgrounds/sunny-stream.jpg": 22406,
	"./backgrounds/sunset-hills.svg": 74230,
	"./backgrounds/sunset.svg": 52561,
	"./backgrounds/sunspot-galaxy.svg": 30072,
	"./backgrounds/thinking-monkey.jpg": 73316,
	"./backgrounds/tropics.jpg": 52544,
	"./backgrounds/water.png": 27819,
	"./backgrounds/waterfall.jpg": 18732,
	"./backgrounds/waterfalls.svg": 74454,
	"./backgrounds/wave.png": 98983,
	"./backgrounds/waves.svg": 88859,
	"./backgrounds/whale-sunset.jpg": 89206,
	"./icons/collect-highlights.svg": 66440,
	"./icons/edgenuity.svg": 50012,
	"./icons/green-circle-check.png": 61854,
	"./icons/guided-notes.svg": 98572,
	"./icons/language-translation.svg": 50408,
	"./icons/loader.svg": 44317,
	"./icons/logo-bug.svg": 31944,
	"./icons/math-icon-3-5.svg": 73366,
	"./icons/math-icon-k-2.svg": 17441,
	"./icons/math-icon.png": 66599,
	"./icons/math-icon.svg": 58728,
	"./icons/my-path-logo.svg": 53942,
	"./icons/my-path.svg": 57446,
	"./icons/reading-icon.png": 40909,
	"./icons/reading-icon.svg": 74738,
	"./icons/red-circle-xmark.png": 1345,
	"./icons/sel-3-5-icon.svg": 5092,
	"./icons/sel-k-2-icon.svg": 28097,
	"./icons/star.svg": 79548,
	"./icons/text-to-speech.svg": 71596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24924;